import React from "react";
import styled from "@emotion/styled";
import { Wrapper } from "../Wrapper";

const Text = styled.h2`
  font-size: 34px;
  font-weight: bold;
  line-height: 1.3;
  margin-bottom: 30px;
  padding-top: 30px;
`;

export type SubheadingProps = {
  data: {
    body: string;
  };
};

export const Subheading = ({ data }: SubheadingProps) => (
  <Wrapper>
    <Text>{data.body}</Text>
  </Wrapper>
);
